import { useAxios } from '@/hooks/useAxios';
import type { WeightConfig } from '@/sections/customerManagement/types';
import { type QueryStatus, useQuery } from '@/utils/api';

export function useLeaderboardWeights(): {
  weights: WeightConfig | undefined;
  status: QueryStatus;
} {
  const axios = useAxios({ doNotImpersonate: true });

  const query = useQuery({
    queryKey: ['leaderboard-weights'],
    queryFn: async () => {
      const { data } = await axios.get<WeightConfig>('/leaderboard/weights');
      return data;
    },
    defaultErrorMessage: 'Failed to load leaderboard weights',
    staleTime: 30 * 60 * 1000,
  });

  return { weights: query.data, status: query.status };
}
